export enum EToolMode {
  NONE,
  SUPPLIER,
  PREMIUM,
  SOURCE,
  RFI,
  CONTRACT,
  AUCTION,
  KPI,
  BOOK_AND_CONTROL,
  NETWORK_OPTIMIZER,
  TOLL_TOOL
}
